var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopCircleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 28C18.4478 28 21.7544 26.6304 24.1924 24.1924C26.6304 21.7544 28 18.4478 28 15C28 11.5522 26.6304 8.24558 24.1924 5.80761C21.7544 3.36964 18.4478 2 15 2C11.5522 2 8.24558 3.36964 5.80761 5.80761C3.36964 8.24558 2 11.5522 2 15C2 18.4478 3.36964 21.7544 5.80761 24.1924C8.24558 26.6304 11.5522 28 15 28Z",
    stroke: "#E72424",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 20H16.5C19 20 20 19 20 16.5V13.5C20 11 19 10 16.5 10H13.5C11 10 10 11 10 13.5V16.5C10 19 11 20 13.5 20Z",
    fill: "#E72424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopCircleFill);
export default __webpack_public_path__ + "static/media/stop-circle-fill.cb65a572e01d65996d80ebc9240658f1.svg";
export { ForwardRef as ReactComponent };